import { format } from 'date-fns'

export function computeRiskLayersTimeExtent() {
  const min = new Date()
  const max = new Date()
  min.setUTCHours(0, 0, 0, 0)
  max.setUTCHours(0, 0, 0, 0)
  min.setTime(min.getTime())
  max.setTime(max.getTime() + 1000 * 60 * 60 * 24 * 6)

  return { min, max }
}

export const prior3Date = new Date(new Date().setDate(new Date().getDate() - 3))
export const prior30Date = new Date(new Date().setDate(new Date().getDate() - 30))
export const prior7Date = new Date(new Date().setDate(new Date().getDate() - 7))
export const prior1Date = new Date(new Date().setDate(new Date().getDate() - 1))

export function getTimeExtent(date: Date) {
  return `${getDate(date)}/${getDate(new Date())}`
}

const getDate = (date: Date) => {
  return format(date, 'yyyy-MM-dd')
}

/** Key identifying a calendar day regardless of how it is displayed. */
export const dayKey = (date: Date | string) => getDate(new Date(date))

export function getForecastDays(count: number, from = new Date()): Date[] {
  return Array.from({ length: count }, (_, i) => {
    const day = new Date(from)
    day.setDate(from.getDate() + i)
    return day
  })
}
